import React from 'react';
import { useCanMutate } from '../../hooks/useCanMutate';

/**
 * Renderiza hijos solo si el usuario puede crear/editar/eliminar.
 */
const MutateGate = ({ children, fallback = null }) => {
  const canMutate = useCanMutate();
  if (!canMutate) {
    return fallback;
  }
  return <>{children}</>;
};

export default MutateGate;
